"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBar = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var nav_lines_svg_1 = __importDefault(require("../../assets/images/nav-lines.svg"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var SideNavMenu_1 = require("../SideNavMenu/SideNavMenu");
var InfoBarContainer = styled_components_1.default.div.attrs({
    className: 'tws-infobar-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\theight: 80px;\n\twidth: ", ";\n\tdisplay: ", ";\n\tbox-shadow: ", ";\n\talign-items: ", ";\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\theight: 64px !important;\n\t}\n"], ["\n\tbackground-color: ", ";\n\theight: 80px;\n\twidth: ", ";\n\tdisplay: ", ";\n\tbox-shadow: ", ";\n\talign-items: ", ";\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\theight: 64px !important;\n\t}\n"])), globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.fullWidth, globalVars_module_scss_1.default.displayInlineFlex, globalVars_module_scss_1.default.shadow2, globalVars_module_scss_1.default.alignCenter);
InfoBarContainer.displayName = 'InfoBarContainer';
var SideMenuToggleWrapper = (0, styled_components_1.default)('div').attrs({
    className: 'tws-sidenav-toggle-wrapper',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbackground: ", ";\n\tdisplay: ", ";\n\talign-items: ", ";\n\tjustify-content: ", ";\n\theight: ", ";\n\twidth: 74px;\n\tcursor: pointer;\n\timg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmax-width: 56px;\n\t\twidth: 100%;\n\t}\n"], ["\n\tbackground: ", ";\n\tdisplay: ", ";\n\talign-items: ", ";\n\tjustify-content: ", ";\n\theight: ", ";\n\twidth: 74px;\n\tcursor: pointer;\n\timg {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmax-width: 56px;\n\t\twidth: 100%;\n\t}\n"])), globalVars_module_scss_1.default.secondaryBlue, globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, globalVars_module_scss_1.default.alignCenter, globalVars_module_scss_1.default.fullHeight);
SideMenuToggleWrapper.displayName = 'SideMenuToggleWrapper';
var SidevNavToggle = styled_components_1.default.a.attrs({
    className: 'sidevNavToggle tws-sidenav-toggle',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
SidevNavToggle.displayName = 'SidevNavToggle';
var InfoBar = /** @class */ (function (_super) {
    __extends(InfoBar, _super);
    function InfoBar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSideMenuToggleClick = function (event) {
            _this.setState({
                isOpen: !_this.state.isOpen,
            });
            event.preventDefault();
        };
        _this.infoBarContainerRef = React.createRef();
        _this.state = {
            isOpen: false,
        };
        _this.handleScroll = _this.handleScroll.bind(_this);
        return _this;
    }
    InfoBar.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(InfoBarContainer, { className: this.props.className, ref: this.infoBarContainerRef },
                this.props.sideNavMenuItems && this.props.sideNavMenuItems.length > 0 ? (React.createElement(SideMenuToggleWrapper, { onClick: this.handleSideMenuToggleClick },
                    React.createElement(SidevNavToggle, { href: '#' },
                        React.createElement("img", { src: nav_lines_svg_1.default })))) : null,
                this.props.children),
            this.props.sideNavMenuItems && this.props.sideNavMenuItems.length > 0 ? (React.createElement(SideNavMenu_1.SideNavMenu, { isOpen: this.state.isOpen, menuModel: this.props.sideNavMenuItems })) : null));
    };
    InfoBar.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.handleScroll);
    };
    InfoBar.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleScroll);
    };
    InfoBar.prototype.handleScroll = function () {
        var lastScrollTop = 40;
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            // downscroll code
            if (this.infoBarContainerRef) {
                var heightBefore = document.body.scrollHeight;
                this.infoBarContainerRef.current.style.cssText = 'height: 64px;top:0;z-index: 1020; position: fixed;';
                if (document.body.style.minHeight === '') {
                    document.body.style.minHeight = heightBefore + 'px';
                }
            }
        }
        else {
            // upscroll code
            if (this.infoBarContainerRef) {
                this.infoBarContainerRef.current.style.cssText = 'height: 80px';
                document.body.style.minHeight = '';
            }
        }
        lastScrollTop = st <= 0 ? 0 : st;
    };
    return InfoBar;
}(React.Component));
exports.InfoBar = InfoBar;
var templateObject_1, templateObject_2, templateObject_3;
